export const WA_BASE_URL = 'https://api.whatsapp.com/send?'
export const WA_NUMBER_PREFIX = 'phone='
export const WA_NUMBER = '+918861115000'
export const WA_TEXT_PREFIX = '&text='
export const WA_TEXT =
    'Hi Openhouse! I have a query about the OH meets. Kindly guide me through it.'
export const WA_URL = `${WA_BASE_URL}${WA_NUMBER_PREFIX}${WA_NUMBER}${WA_TEXT_PREFIX}${WA_TEXT}`
